export interface Registro {
  id: number;
  nombre: string;
  telefono: string;
  created?: string;
  modified?: string;
}

export interface RegistroForm {
  nombre: string;
  telefono: string;
}

export const NOMBRE_MAX = 150;
export const TELEFONO_MAX = 40;
